// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"131":"fdd9b165","194":"60746b71","260":"4fe7ae33","668":"a2793d2f","675":"806f7a6c","762":"5bf4a386","811":"e06f8616","902":"9febde2e","973":"78b2f864","983":"33b40dae"}[chunkId] + ".js";
};